module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unit,
      "label": "Select",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.unitFrom.text),
      callback: function($$v) {
        _vm.$set(_vm.unitFrom, "text", $$v)
      },
      expression: "unitFrom.text"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unit,
      "label": "Select",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.unitTo.text),
      callback: function($$v) {
        _vm.$set(_vm.unitTo, "text", $$v)
      },
      expression: "unitTo.text"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "grid-list-md": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "From",
      "type": "number"
    },
    model: {
      value: (_vm.valueFrom),
      callback: function($$v) {
        _vm.valueFrom = $$v
      },
      expression: "valueFrom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": "",
      "md6": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.valueTo ? _vm.valueTo : 'To',
      "disabled": "",
      "type": "number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_vm._v("Copy")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Exponent",
      "color": "primary"
    },
    model: {
      value: (_vm.exponent),
      callback: function($$v) {
        _vm.exponent = $$v
      },
      expression: "exponent"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg2": "",
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Round number",
      "color": "primary"
    },
    model: {
      value: (_vm.round),
      callback: function($$v) {
        _vm.round = $$v
      },
      expression: "round"
    }
  })], 1), _vm._v(" "), (_vm.round) ? _c('v-flex', {
    attrs: {
      "lg3": "",
      "sm3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": ("Rounding number to " + _vm.roundNumber + " decimal places")
    },
    model: {
      value: (_vm.roundNumber),
      callback: function($$v) {
        _vm.roundNumber = $$v
      },
      expression: "roundNumber"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "bottom": true,
      "color": "primary"
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Copy successful\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11a5f10f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConvertBox.vue
// module id = 92
// module chunks = 0